import { render } from "./external_show_page.vue?vue&type=template&id=60bbdad7"
import script from "./external_show_page.vue?vue&type=script&lang=js"
export * from "./external_show_page.vue?vue&type=script&lang=js"

import "../login/css/login.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__